import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class MantenedoraService {
    private urlModulo = `${environment.urlAPI}/mantenedora`;

    constructor(private http: HttpClient) { }

    /**
     * Recupera a lista das mantenedoras no sistema
     */
    public getListaMantenedora(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-lista`)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.mantenedoras);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera mantenedora pelo ID
     */
    public getMantenedoraById(id: number): Promise<any> {
        const params = new HttpParams().set('id', id.toString());
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-byid`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.mantenedora);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Salva dados da mantenedora
     */
    public gravaMantenedora(obj: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-salvar`, obj)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Ativa/Inativa uma mantenedora
     */
    public inativarMantenedora(codigo: number, inativo: boolean): Promise<any> {
        const payload = { codigo: codigo, inativo: inativo };
        
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-inativar`, payload)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }
}


// WEBPACK FOOTER //
// /app/src/app/services/mantenedora.service.ts